import { SUGGESTION } from "../constants";

export function extractNodeIdFromSuggestedNodeId(nodeId: string) {
  // Extract real nodeId if this is an AI suggested node
  return nodeId.startsWith(`${SUGGESTION}-`) ? nodeId.split("::")[1] : nodeId;
}
